// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"986d7722","172":"3785e527","342":"a80175fa","453":"3d6eaeff","582":"9fb9e748","936":"27f3e62c","981":"0f3eb41f"}[chunkId] + ".chunk.js";
};